import React from 'react';
import { compose, join, juxt, toUpper, head, tail } from 'ramda';
import format from 'string-template';

import styleFile from './RichText.js';
import Icon from '../Icon';
import PropertyManager from '../../HoC/propertyManager';
import { withThemeJSS } from '../../providers/themeProvider';
import { withContent } from '../../providers/translateProvider';

const capitalize = compose(
  join(''),
  juxt([
    compose(
      toUpper,
      head
    ),
    tail
  ])
);
const RichText = class RichText extends React.Component {
  static displayName = 'RichText';
  render() {
    const { children, config, theme, content} = this.props;
    const quantityOrPlural = typeof config.quantity === 'number' ? config.quantity : config.plural || false;

    let text = config.text || config.dangerouslySetInnerHTML || children;
    if (text && content && config.translate) {
      text = content.t(text, quantityOrPlural);

      if (config.withVars) {
        let translatedWithVars = {};
        Object.keys(config.withVars).forEach(key => {
          translatedWithVars[key] = content.t(config.withVars[key]);
        });

        text = format(text, translatedWithVars);
      }
    }

    let textLabel = config.ariaLabel;

    if (textLabel && content && config.translate) {
      textLabel = content.t(textLabel, quantityOrPlural);
    
      if (config.withVars) {
        let translatedWithVars = {};
        Object.keys(config.withVars).forEach(key => {
          translatedWithVars[key] = content.t(config.withVars[key]);
        });
    
        textLabel = format(textLabel, translatedWithVars);
      }
    
    }

    if (text && config.ucFirst) {
      text = capitalize(text.toString());
    }

    return (
      <span className={theme.computedInnerStyle} aria-label={textLabel} tabIndex={config.tabIndex} role={config.role} aria-hidden={config.ariaHidden}>
        {config.icon ? <Icon config={config.icon} /> : ''}
        {config.dangerouslySetInnerHTML ? (
          <span dangerouslySetInnerHTML={{ __html: text }} className={theme.computedInnerStyle} />
        ) : (
          text
        )}
        {config.rightIcon ? <Icon config={config.rightIcon} /> : ''}
      </span>
    );
  }
};

export default compose(
  PropertyManager([
    'config',
    'icon',
    'rightIcon',
    'text',
    'translate',
    'plural',
    'quantity',
    'dangerouslySetInnerHTML',
    'withVars',
    'ucFirst',
    'ariaLabel',
    'role',
    'tabIndex',
    'ariaHidden'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(RichText);
